interface cityItem {
    city: string;
}

export interface IOurOffices {
    offices: Array<cityItem>;
}

export const ourOffices: IOurOffices = {
    offices: [
        {
            city: "Москва",
        },
        {
            city: "Новосибирск",
        },
        {
            city: "Альметьевск"
        },
        {
            city: "Астрахань"
        },
        {
            city: "Барнаул"
        },
        {
            city: "Владивосток"
        },
        {
            city: "Волгоград"
        },
        {
            city: "Воронеж"
        },
        {
            city: "Екатеринбург"
        },
        {
            city: "Ижевск"
        },
        {
            city: "Иркутск"
        },
        {
            city: "Казань"
        },
        {
            city: "Калининград"
        },
        {
            city: "Калуга"
        },
        {
            city: "Кемерово"
        },
        {
            city: "Краснодар"
        },
        {
            city: "Красноярск"
        },
        {
            city: "Липецк"
        },
        {
            city: "Набережные Челны"
        },
        {
            city: "Нижний Новгород"
        },
        {
            city: "Новокузнецк"
        },
        {
            city: "Омск"
        },
        {
            city: "Оренбург"
        },
        {
            city: "Пенза"
        },
        {
            city: "Пермь"
        },
        {
            city: "Ростов-на-Дону"
        },
        {
            city: "Самара"
        },
        {
            city: "Санкт-Петербург"
        },
        {
            city: "Саратов"
        },
        {
            city: "Сочи"
        },
        {
            city: "Ставрополь"
        },
        {
            city: "Стерлитамак"
        },
        {
            city: "Сургут"
        },
        {
            city: "Тольятти"
        },
        {
            city: "Томск"
        },
        {
            city: "Тула"
        },
        {
            city: "Тюмень"
        },
        {
            city: "Ульяновск"
        },
        {
            city: "Уфа"
        },
        {
            city: "Челябинск"
        },
        {
            city: "Череповец"
        },
        {
            city: "Ярославль"
        }
    ],
};
